module.exports = __webpack_public_path__ + "img/Scott_Mackay.80e6817b.jpg";